import React from "react";
import { SliderPage } from ".";
import { PrintAgentOptions } from "../components/order/print/PrintAgentOptions";
import { PrintInternalOptions } from "../components/order/print/PrintInternalOptions";
import { isInternal } from "../helpers";
import { Notes } from "../components/fields";

export const PrintPage = () => {
  return (
    <SliderPage title="Print">
      {!isInternal() ? <PrintAgentOptions /> : <PrintInternalOptions />}
      <Notes
        name="notes.print"
        label={
          isInternal()
            ? "Print Notes"
            : "Need something else printed? Describe it below and we will be in touch."
        }
      />
    </SliderPage>
  );
};
